import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'components/Dropdown';

const ParameterDropdownComponent = ({ label, ...props }) => (
  <div className="main-dropdown mb-20">
    <p className="main-dropdown__label">
      {label}
    </p>

    <Dropdown
      {...props}
      placeholder="Select a Variable"
      isClearable
      noOptionsMessage={() => 'Select more variables to perform this kind of test.'}
    />
  </div>
);

ParameterDropdownComponent.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ParameterDropdownComponent;
